import { render, staticRenderFns } from "./elCavas.vue?vue&type=template&id=e5115b00&scoped=true"
import script from "./elCavas.vue?vue&type=script&lang=js"
export * from "./elCavas.vue?vue&type=script&lang=js"
import style0 from "./elCavas.vue?vue&type=style&index=0&id=e5115b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5115b00",
  null
  
)

export default component.exports